// ===== ContractorListingGrid.tsx =====
import React from 'react';
import { Row, Col } from 'reactstrap';
import ContractorCard from './ContractorCard';
import { Contractor } from '../../models/Contractor.interface';
import ContractorListingGridSkeleton from './ContractorListingGridSkeleton';

interface ContractorListingGridProps {
  contractors: Contractor[];
  loading: boolean;
  urlParams?: {
    state?: string;
    city?: string;
    category?: string;
  };
}

const ContractorListingGrid: React.FC<ContractorListingGridProps> = ({
  contractors,
  loading
}) => {

  // Show skeleton while loading
  if (loading) {
    return <ContractorListingGridSkeleton />;
  }

  /*
  if (contractors.length === 0) {
    return (
      <div className="text-center py-5 bg-light rounded">
        <h5 className="mb-3">No contractors found</h5>
        <p className="text-muted mb-0">
          Try adjusting your search or filter criteria to find contractors.
        </p>
      </div>
    );
  }
  */
 
  return (
    <Row className="g-3">
      {contractors.map(contractor => (
        <Col key={contractor.contractorId} xs={12} md={6} lg={4}>
          <ContractorCard contractor={contractor} />
        </Col>
      ))}
    </Row>
  );
};

export default ContractorListingGrid;